// utils
import { haveProperty } from '@/utils/';

// hooks
import { buildContactsToAPI } from '@/hooks/use-contacts';

/**
 *
 * Criação do objecto de user.
 * Esta função irá preparar o objecto a ser enviado para API, onde só os campos
 * preenchidos na página é que serão enviados. Assim irá permitir usar esta função
 * na adição e na edição deste modelo.
 *
 * @param {Object}  data
 *
*/
const create = ( data, helpers ) => {
    const { mobile, phone } = data;

    // construção da estrutura dos contactos
    // do utilizador.
    const contacts = buildContactsToAPI( [
        { type: 'phone', value: phone },
        { type: 'mobile', value: mobile }
    ], helpers );

    const user = {
        ...( haveProperty( data, 'name' ) && { name: data.name }),
        ...( haveProperty( data, 'taxpayerIdentificationNumber' ) && { taxpayer_identification_number: data.taxpayerIdentificationNumber }),
        ...( haveProperty( data, 'nationalIdentificationNumber' ) && { national_identification_number: data.nationalIdentificationNumber }),
        ...( haveProperty( data, 'state' ) && { state_id: data.state }),
        ...( haveProperty( data, 'address' ) && { address: data.address }),
        ...( haveProperty( data, 'email' ) && { email: data.email }),
        ...( haveProperty( data, 'roleId' ) && { role_id: data.roleId }),
        ...( haveProperty( data, 'parentId' ) && { parent_id: data.parentId }),
        ...( ( data.clientId || data.clientId === '' ) && { client_id: data.clientId }),
        ...( Object.keys( contacts ).length && { ...contacts }),
        ...( haveProperty( data, 'observations' ) && { observations: data.observations })
    };

    return user;
};

const requiredFields = [
    { field: 'name', isRequiredOnEdit: false },
    { field: 'email', isRequiredOnEdit: false },
    { field: 'roleId', isRequiredOnEdit: false }
];

export {
    create,
    requiredFields
};